import { render, staticRenderFns } from "./ButtonWechat.vue?vue&type=template&id=cb5f8116&scoped=true&lang=pug&"
import script from "./ButtonWechat.vue?vue&type=script&lang=js&"
export * from "./ButtonWechat.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWechat.vue?vue&type=style&index=0&id=cb5f8116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5f8116",
  null
  
)

export default component.exports